import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img',
  standalone: true,
})
export class ImageErrorDirective {
  // default is a transparent image
  @Input() imageError = 'assets/images/all-img/profileBg.svg';

  @HostListener('error', ['$event'])
  handleError(event: ErrorEvent): void {
    console.log('event', event);
    // (event.target as HTMLImageElement).src = this.imageError;
  }
}
